import api from 'utils/api';

/**
 * Clean filter params: strips null, undefined, and empty string keys.
 */
function cleanParams(params = {}) {
  const cleaned = {};
  Object.keys(params).forEach((key) => {
    const val = params[key];
    if (val !== undefined && val !== null && val !== '') {
      cleaned[key] = val;
    }
  });
  return cleaned;
}

/**
 * List Customer Refund Requests
 * GET /api/admin/payment/refund-requests
 * @param {Object} params - { page, limit, status, order_id, customer_id }
 */
export const listRefundRequests = async (params = {}) => {
  const res = await api.get('/admin/payment/refund-requests', {
    params: cleanParams(params)
  });
  return res.data;
};

/**
 * Get Refund Request Details
 * GET /api/admin/payment/refund-requests/:id
 * @param {string|number} id - Refund Request ID
 */
export const getRefundRequestDetail = async (id) => {
  const res = await api.get(`/admin/payment/refund-requests/${id}`);
  return res.data;
};

/**
 * List Payment Transactions
 * GET /api/admin/payment/transactions
 * @param {Object} params - { page, limit, payment_method, payment_status, search, start_date, end_date, sort_by, sort_direction }
 */
export const listTransactions = async (params = {}) => {
  const res = await api.get('/admin/payment/transactions', {
    params: cleanParams(params)
  });
  return res.data;
};

/**
 * Get Transaction Detail
 * GET /api/admin/payment/transaction/:id
 * @param {string|number} id - Payment Transaction ID or Order ID
 */
export const getTransactionDetail = async (id) => {
  const res = await api.get(`/admin/payment/transaction/${id}`);
  return res.data;
};

/**
 * Get Order Payment & Refund Detail
 * GET /api/admin/payment/order/:orderId
 * @param {string|number} orderId - Order ID
 */
export const getOrderPaymentDetail = async (orderId) => {
  const res = await api.get(`/admin/payment/order/${orderId}`);
  return res.data;
};

/**
 * Issue Direct Stripe Refund for a Transaction or Order
 * POST /api/admin/payment/transaction/:id/refund
 * @param {string|number} id - Transaction ID or Order ID
 * @param {Object} body - { amount?: number, reason?: string, note?: string, idempotency_key?: string }
 */
export const refundTransaction = async (id, body = {}) => {
  const payload = {};
  if (body.amount !== undefined && body.amount !== null && body.amount !== '') {
    const num = Number(body.amount);
    if (!isNaN(num) && num > 0) payload.amount = num;
  }
  if (body.reason) payload.reason = body.reason;
  if (body.note) payload.note = String(body.note).trim();
  if (body.idempotency_key) payload.idempotency_key = String(body.idempotency_key).trim();

  const headers = {};
  if (payload.idempotency_key) {
    headers['idempotency-key'] = payload.idempotency_key;
  }

  const res = await api.post(`/admin/payment/transaction/${id}/refund`, payload, { headers });
  return res.data;
};


/**
 * Register or update Admin FCM Device Token
 * PUT /api/admin/notification/fcm-token
 * @param {string} fcmToken - Firebase Cloud Messaging token
 * @param {string} [deviceId] - Optional device identifier
 */
export const updateAdminFcmToken = async (fcmToken, deviceId) => {
  const res = await api.put('/admin/notification/fcm-token', {
    fcm_token: fcmToken,
    device_id: deviceId
  });
  return res.data;
};

export default {
  updateAdminFcmToken,
  listRefundRequests,
  getRefundRequestDetail,
  listTransactions,
  getTransactionDetail,
  getOrderPaymentDetail,
  refundTransaction
};
